<template>
    <div class="section-box">
        <el-tabs v-model="type" type="card" class="customer-tabs-mg">
            <el-tab-pane 
                v-for="(item,index) in eType"
                :label="item.value"
                :name="item.key+''"
                :key="index"
            ></el-tab-pane>
        </el-tabs>
        <div class="customer-list">
            <div class="next-button">
                <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
            </div>
        </div>

         <!-- 列表 -->
        <el-table
            :stripe="true"
            :data="tableData"
            style="width: 100%;margin-top: 20px;"
            height="590"
            border
            v-loading="listLoading" 
            >
            <!-- eslint-disable  -->
            <el-table-column label="企业ID">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.companyId" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.companyId || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="企业名称">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.companyName" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.companyName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="地区">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="region" placeholder="请选择" @click.native="isRegionShow"/>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="scope.row.provinceName">{{scope.row.provinceName}}{{scope.row.cityName}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="联系人">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.contacts" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.contacts || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="联系方式">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.phone" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.phone || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="企业类型">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" 
                            placeholder="请选择" 
                            v-model="form.enterpriseRoleCode" 
                            style="width: 100%;"
                        >
                            <el-option
                                v-for="(item,index) in companyRolesList"
                                :value="item.rolescode" 
                                :label="item.rolesname"
                                :key="index"
                            ></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.enterpriseRole || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="注册时间">
                <el-table-column show-overflow-tooltip  width="240">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.timeDate"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                        >
                        </el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.ctime || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="操作" width="160" fixed="right">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="linkInfoFun(scope.row.companyId)">详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.pageNum"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog 
            :visible.sync="areaShow" 
            title="地区" 
            width="34%" 
            ref="dialog"
            append-to-body
        >
            <el-form ref="area" label-width="60px" >
                <el-form-item label="地址：">
                    <el-select 
                        size="medium" 
                        value-key="aid"
                        v-model="regionForm.ProvinceId"
                        placeholder="省"
                        filterable
                        clearable
                        style="width: 48%;margin-right: 10px;"
                        @change="ProvinceIdFun"
                    >
                        <el-option 
                            v-for="(item, index) in ProvinceIdList" 
                            :value="item" 
                            :label="item.areaname" 
                            :key="index"
                        ></el-option>
                    </el-select>
                    <el-select 
                        size="medium" 
                        value-key="aid" 
                        v-model="regionForm.CityId" 
                        placeholder="市" 
                        filterable 
                        clearable 
                        style="width: 48%;margin-right: 10px;" 
                    >
                        <el-option 
                            v-for="(item, index) in CityIdList" 
                            :value="item" 
                            :label="item.areaname" 
                            :key="index"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitAddressFun">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import {
        getCompanyList,       //列表
        seasAdd,        //添加
    } from "@/service/customerInformation";
    import {
        companyRoles,       //企业类型
        optionsArea,        //省市区
    } from "@/service/area";
    import { 
        getActionData
    } from '@/utils/store'
    export default {
        data() {
            return {
                actionData: JSON.parse(getActionData()),      //功能按钮每个页面必须用
                type: '1',
                eType: [
                    {
                        value: '企业',
                        key: 1
                    }
                ],
                listLoading: false,
                form: {
                    pageNum: 1,
                    pageSize: 10,

                    companyId: '',          //企业id
                    companyName: '',        //企业名称
                    // provinceId: '',         //省份id
                    // cityId: '',             //城市id
                    contacts: '',           //联系人
                    phone: '',              //联系方式
                    enterpriseRoleCode: '', //企业角色
                    timeDate: [],
                    // ctimeStart: '',         //注册开始时间
                    // ctimeEnd: '',           //注册结束时间
                },
                searchData:{},
                oraginForm:{},
                total: 0,                       //总条数
                tableData:[],
                companyRolesList: [],           //企业类型

                // 地区
                areaShow: false,
                region: '', 
                regionForm: {
                    ProvinceId: '', //省
                    CityId: '', //市
                },

                ProvinceIdList: [],
                CityIdList: [],
            };
        },
        // activated(){
        //     this.handleSearch()
        // },
        created() {
            this.oraginForm = JSON.parse(JSON.stringify(this.form))
            this.tableData = [];
            this.handleSearch()
            this.getCompanyRoles();
        },
        methods: {
            //企业类型
            getCompanyRoles(){
                companyRoles().then(res=> {
                    this.companyRolesList = res.Data
                })
            },
            // 查询
            handleSearch() {
                this.searchData = Object.assign({}, this.form)
                this.handleCurrentChange(1)
            },
            // 重置
            handleReset() {
                this.regionForm = {
                    ProvinceId: '', //省
                    CityId: '', //市
                    XianId: '', //区
                }
                this.region = ''
                this.form = JSON.parse(JSON.stringify(this.oraginForm))
                this.handleSearch()
            },
            handleSizeChange(val) {
                if (this.listLoading) return
                this.form.pageNum = 1
                this.form.pageSize = val
                this.searchData.pageNum = 1
                this.searchData.pageSize = val
                this.GetCompanyList()
            },
            handleCurrentChange(val) {
                if (this.listLoading) return
                this.form.pageNum = val
                this.searchData.pageNum = val
                this.GetCompanyList()
            },
            //获取公海客户列表
            async GetCompanyList(){
                this.listLoading = true
                let data = JSON.parse(JSON.stringify(this.searchData))
                data.rational = true

                !data.companyId && delete data.companyId
                !data.companyName && delete data.companyName
                !data.contacts && delete data.contacts
                !data.phone && delete data.phone
                !data.enterpriseRoleCode && delete data.enterpriseRoleCode
                data.provinceId = this.regionForm.ProvinceId.aid
                data.cityId = this.regionForm.CityId.aid
                !data.provinceId && delete data.provinceId
                !data.cityId && delete data.cityId
                if (data.timeDate && data.timeDate.length) {
                    data.ctimeStart = data.timeDate[0]
                    data.ctimeEnd = data.timeDate[1]
                }
                delete data.timeDate
                let res = await getCompanyList(data)
                this.listLoading = false
                if(res.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                this.tableData = res.Data.datas
                this.total = res.Data.total
            },
            // 点击新增
            handleOpen(){
                this.$refs.addCustomer.open()
            },

            // 地区
            isRegionShow(){
                this.areaShow = true
                this.$nextTick(()=>{
                    this.getAreaDataByParentFun(0,1)
                })
            },
            // 点击省份
            ProvinceIdFun(){
                this.getAreaDataByParentFun(this.regionForm.ProvinceId.aid,2)
                this.regionForm.CityId = {aid : '',areaname: ''}
            },
            // 点击地址确定
            submitAddressFun(){
                if(this.regionForm.CityId.areaname) {
                    this.region = this.regionForm.ProvinceId.areaname + this.regionForm.CityId.areaname
                }else{
                    this.region = this.regionForm.ProvinceId.areaname 
                }
                this.areaShow = false
            },

            //获取地址
            async getAreaDataByParentFun(id,hier){
                let data = {
                    aid: id,
                    areaType: hier
                }
                let res = await optionsArea(data)
                    switch(hier){
                        case 1:
                            this.ProvinceIdList = res.Data
                            // console.log('省')
                            break;
                        default:
                            this.CityIdList = res.Data
                            // console.log('市')
                    }
            },
            // 跳转到客户信息
            linkInfoFun(id) {
                this.$router.push('/customer/enterpriseCustomerInfo?companyId='+ id)
            },
        }
    };
</script>
<style  lang="scss">
    .customer-tabs-mg {
        .el-tabs__header {
            margin: 0 0 15px !important;
        }
    }
    .customer-list {
        position: relative;
        .next-button {
            position: absolute;
            right: 0;
            top: -56px;
        }
    }
    .customer-row-bg {
        padding: 20px 14px;
        background-color: #f9fafc;
        display: flex;
        align-items: center;
        .el-form-item {
            margin-bottom: 0 !important;
        }
        .selected {
            color: #409EFF;
            border-color: #c6e2ff;
            background-color: #ecf5ff;
        }
    }
    .linkInfo {
        cursor: pointer;
        &:hover {
            color: #409EFF;
        }
    }
</style>